import React from "react";
import { useNavigate } from "react-router-dom";

// Shown INSIDE the Add/Edit dancer modal when the server refuses the save
// because the same child (name + birth year) is already active on another
// Feis.link account (409 DANCER_EXISTS_OTHER_ACCOUNT). Replaces the form —
// this is a product state with actions, not a validation error: the parent
// either goes and signs in to the account that has the child, asks us, or
// goes back to fix a typo. (Follow-up: "Request access" — link a dancer to a
// second parent account — once linked guardians exist.)
const DancerExistsPanel = ({ name, birthYear, onBack }) => {
  const navigate = useNavigate();
  const signInElsewhere = () => {
    // Same teardown the API layer does on 401/403: drop this session and land
    // on the login screen so the parent can use the other account.
    localStorage.clear();
    navigate("/login");
  };
  return (
    <div className="dancerExists" role="alert" data-testid="dancer-exists-panel">
      <p className="dancerExists__title">This dancer already exists</p>
      <p className="dancerExists__body">
        <strong>{name}</strong>
        {birthYear ? ` (born ${birthYear})` : ""} is already registered on another Feis.link account.
      </p>
      <p className="dancerExists__hint">
        If that account is yours, sign in there. If it belongs to a co-parent, please register from that account.
      </p>
      <div className="dancerExists__actions">
        <button type="button" className="updateChange dancerExists__primary" onClick={signInElsewhere}>
          Sign in to that account
        </button>
        <a className="dancerExists__secondary" href="mailto:info@feis.link?subject=Dancer%20already%20exists">
          Contact us
        </a>
      </div>
      <button type="button" className="dancerExists__back" onClick={onBack}>
        Back
      </button>
    </div>
  );
};

export default DancerExistsPanel;
